import moment from 'moment';
import React from 'react';

import { CaregiverRelationship } from '@vestahealthcare/common/enums';
import { Patient } from '@vestahealthcare/common/models';
import {
  DATE_FORMAT_SHORT,
  DATE_FORMAT_SHORT_WITH_TIME,
} from '@vestahealthcare/common/utils/constants';

import { PhoneLink } from 'styleguide-v2';

import { DetailItem } from '../utils';

type Props = {
  member?: Patient;
};

export const MemberVirtualVisitDetail = ({ member }: Props) => {
  if (!member) return <></>;

  const {
    virtualVisitDate: date,
    virtualVisitPlatform: platform,
    virtualVisitStatus: status,
    virtualVisitHostName: name,
    virtualVisitHostRelationship: relationship,
    virtualVisitHostRelationshipOther: relationshipOther,
    virtualVisitHostPhoneNumber: number,
    virtualVisitHasTime: hasTime,
  } = member;

  if (!date && !status && !name && !platform && !number && !relationship)
    return (
      <DetailItem namespace="programDetailsCard" label="virtualVisitInfo" />
    );

  const getVVInfo = () => (
    <DetailItem namespace="programDetailsCard" label="virtualVisitInfo">
      {!!date &&
        moment
          .unix(date)
          .format(hasTime ? DATE_FORMAT_SHORT_WITH_TIME : DATE_FORMAT_SHORT)}
      {!!status && <p className="small no-margin">[{status?.toString()}]</p>}
      {!!platform && (
        <p className="small no-margin">[{platform?.toString()}]</p>
      )}
    </DetailItem>
  );

  const getVVHost = () => (
    <DetailItem namespace="programDetailsCard" label="virtualVisitHost">
      {name}{' '}
      {relationship && (
        <span className="small">
          [
          {relationship === CaregiverRelationship.OTHER
            ? relationshipOther
            : relationship.toString()}
          ]
        </span>
      )}
      {number && <PhoneLink compact phone={number.toString()} />}
    </DetailItem>
  );

  return (
    <>
      {(date || status || platform) && getVVInfo()}
      {(name || relationship || number) && getVVHost()}
    </>
  );
};
